import React from 'react';
import { Box, Typography, Divider } from '@mui/material';
import { LEGAL_TERMS_VERSION } from '../../constants';

const Terms: React.FC = () => {
  return (
    <Box sx={{ width: '100%', maxWidth: 760, mx: 'auto', py: { xs: 3, sm: 5 } }}>
      <Typography variant="h4" gutterBottom sx={{ fontWeight: 800, letterSpacing: '-0.02em' }}>
        Terms of Service
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Effective version: {LEGAL_TERMS_VERSION}
      </Typography>
      <Divider sx={{ mb: 4 }} />

      <Typography variant="h6" gutterBottom sx={{ fontWeight: 800, letterSpacing: '-0.01em', color: 'primary.main' }}>1. Overview</Typography>
      <Typography paragraph color="text.secondary" sx={{ mb: 3 }}>
        Dragonsframe is a student community platform for connecting with other students, joining groups, and sharing content.
        By using the service, you agree to follow these terms and all related policies.
      </Typography>

      <Typography variant="h6" gutterBottom sx={{ fontWeight: 800, letterSpacing: '-0.01em', color: 'primary.main' }}>2. Eligibility</Typography>
      <Typography paragraph color="text.secondary" sx={{ mb: 3 }}>
        You must provide accurate account details and keep your credentials secure. You are responsible for activity on your account.
      </Typography>

      <Typography variant="h6" gutterBottom sx={{ fontWeight: 800, letterSpacing: '-0.01em', color: 'primary.main' }}>3. Acceptable Use</Typography>
      <Typography paragraph color="text.secondary" sx={{ mb: 3 }}>
        You agree not to post unlawful, abusive, harassing, discriminatory, or misleading content, and not to interfere with the platform.
        We may remove content or restrict accounts that violate these rules.
      </Typography>

      <Typography variant="h6" gutterBottom sx={{ fontWeight: 800, letterSpacing: '-0.01em', color: 'primary.main' }}>4. User Content</Typography>
      <Typography paragraph color="text.secondary" sx={{ mb: 3 }}>
        You keep ownership of content you submit. You grant us permission to host and display that content only as needed to run and improve the service.
      </Typography>

      <Typography variant="h6" gutterBottom sx={{ fontWeight: 800, letterSpacing: '-0.01em', color: 'primary.main' }}>5. Service Changes</Typography>
      <Typography paragraph color="text.secondary" sx={{ mb: 3 }}>
        We may update or improve features over time. If these terms materially change, we may require you to review and accept the updated version.
      </Typography>

      <Typography variant="h6" gutterBottom sx={{ fontWeight: 800, letterSpacing: '-0.01em', color: 'primary.main' }}>6. Termination</Typography>
      <Typography paragraph color="text.secondary" sx={{ mb: 3 }}>
        We may suspend or terminate accounts that violate these terms or applicable law, or that create security or safety risks.
      </Typography>

      <Typography variant="h6" gutterBottom sx={{ fontWeight: 800, letterSpacing: '-0.01em', color: 'primary.main' }}>7. Contact</Typography>
      <Typography paragraph color="text.secondary" sx={{ mb: 3 }}>
        Questions about these terms can be sent to the Dragonsframe team through the support channel listed in-app.
      </Typography>
    </Box>
  );
};

export default Terms;
